// load JSZIP file to support export excel by wijmo flexgrid
// It is global because it must to be added to window namespace
import JSZip from "jszip";
window["JSZip"] = JSZip;